import styled, { css } from 'styled-components';
import { StoreLogoWrapper } from './StoreLogo.types';
import KarmaLogo from '../KarmaLogo/KarmaLogo';

export const StoreLogoWrap = styled.div<StoreLogoWrapper>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme[theme.color].StoreLogo.border};
  background: #fff;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  ${({ $width, $height }) => css`
    min-width: ${$width}px;
    min-height: ${$height}px;
    max-width: ${$width}px;
    max-height: ${$height}px;
  `}
  overflow: hidden;
`;

export const StoreLogoImage = styled.img`
  object-fit: contain;
`;

export const KarmaLogoWrapper = styled(KarmaLogo)`
  color: ${({ theme }) => theme[theme.color].StoreLogo.placeholder};
`;
